
const scrollToUnsignedInvestment = investments => {
  const unsignedInvestment = investments
    .find(investment => !(investment.isSigned || investment.isPartiallySigned))

  if (!unsignedInvestment) {
    return
  }

  const { id } = unsignedInvestment

  const element = document.getElementById(id)

  if (!element) {
    return
  }

  element.scrollIntoView({ behavior: 'smooth' })
}

export default scrollToUnsignedInvestment
